import React from "react";
import firstImage from "../assets/images/second.png";
import googleButton from "../assets/images/google-play-badge 2.png";
import chattingImg from "../assets/images/beautiful-rendering-dating-app-concept 1.png";
import chatImage from "../assets/images/chat_ image.png";

const FirstPage = () => {
  return (
    <>
      <img
        src={chatImage}
        alt="chat image"
        className="absolute top-10 pt-15 right-10 w-[100px] sm:w-[200px] md:w-[200px] h-auto social-img lg-ml-[10px] custom-chat-image xxl:hidden"
      />
      <div className="container mx-auto flex flex-col items-center text-center sm:flex-row sm:justify-between px-4 py-8 md:py-16 mt-[70px]  md:mt-[10px] mainbanner-class">
        <div className="w-full sm:w-1/2 text-center sm:text-left sm:-mt-24 main-block mb-0 sm:mb-0">
          <p className="text-2xl sm:text-3xl lg:text-3xl font-bold mt-4">
            <span className="text-[#2DBC78] font-bold text-5xl leading-relaxed logo-name">
              Quick Chat{" "}
            </span>
            <br />

            <span className="font-bold leading-relaxed content-size sm:text-xl lg:text-2xl block sm:inline whitespace-nowrap sm:mb-0 -mb-8 ">
              Bridging Distances with
            </span>
            <br />
            <span className="font-bold leading-relaxed content-size sm:text-xl lg:text-2xl block sm:inline whitespace-nowrap ">
              Secure Conversations.
            </span>
          </p>

          <div className="flex justify-center sm:justify-start mt-2">
            <a
              href="https://play.google.com/store/apps/details?id=com.sstech.quickchat"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={googleButton}
                alt="Google Play Button"
                className="w-32 h-auto sm:w-52 -ml-2 google-btn"
              />
            </a>
          </div>
        </div>
        <div className="flex flex-col items-center sm:flex-row sm:justify-center sm:mt-0 first-img mb-0 sm:mb-0">
          <img
            src={chattingImg}
            alt="Chatting Illustration"
            className="sm:ml-20 sm:-mt-52 chat-img mb-40 sm:mb-0 mt-12 md:mb-40"
          />
          <img
            src={firstImage}
            alt="Illustration"
            className="w-full h-auto sm:h-[500px] sm:w-[330px] sm:-mt-8 lg:-mt-20 xl:-mt-24 -ml-14 girl-img mt-4"
          />
        </div>
      </div>
    </>
  );
};

export default FirstPage;
